export class SplashMessage {
    showSplash = false;
    duration = 8;
  }